export const shouldInlineMap = () => typeof window !== 'undefined' && window && window.innerWidth < 550;
export function empty(){};
